// src/components/ErrorBoundary.js
import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    // Ignorer TOUTES les erreurs Firebase permission
    const msg = error?.message || "";
    const code = error?.code || "";
    if (
      code === "permission-denied" ||
      msg.includes("Missing or insufficient permissions") ||
      msg.includes("permission-denied") ||
      msg.includes("FirebaseError")
    ) {
      return { hasError: false, error: null };
    }
    return { hasError: true, error };
  }

  componentDidCatch(error) {
    const msg = error?.message || "";
    const code = error?.code || "";
    if (
      code === "permission-denied" ||
      msg.includes("Missing or insufficient permissions") ||
      msg.includes("permission-denied")
    ) {
      // Ignorer silencieusement
      this.setState({ hasError: false, error: null });
      return;
    }
    console.error("App error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={s.wrapper}>
          <div style={s.card}>
            <div style={s.icon}>⚠️</div>
            <h2 style={s.title}>Une erreur est survenue</h2>
            <p style={s.desc}>Rechargez la page pour continuer.</p>
            <button onClick={() => window.location.reload()} style={s.btn}>
              🔄 Recharger
            </button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}

const s = {
  wrapper:{minHeight:"100vh",display:"flex",alignItems:"center",justifyContent:"center",background:"#f7f8fc"},
  card:{background:"#fff",borderRadius:"16px",padding:"2.5rem",textAlign:"center",maxWidth:"400px",boxShadow:"0 4px 24px rgba(0,0,0,0.08)"},
  icon:{fontSize:"3rem",marginBottom:"1rem"},
  title:{fontSize:"1.25rem",fontWeight:"700",color:"#1a1a2e",marginBottom:"0.5rem"},
  desc:{color:"#888",fontSize:"0.9rem",marginBottom:"1.5rem"},
  btn:{padding:"0.75rem 2rem",background:"linear-gradient(135deg,#667eea,#764ba2)",color:"#fff",border:"none",borderRadius:"10px",fontWeight:"700",cursor:"pointer"},
};
